<template>
  <v-skeleton-loader type="image" transition="fade-transition" :loading="$apollo.queries.numbers.loading">
    <div>
      <v-row class="px-3 pb-3" justify="end">
        <add-number-external-provider />
      </v-row>
      <v-card class="multi-numbers" min-height="250">
        <v-card-title class="pb-3">
          <span class="table-card-title pl-0 mb-5">Números de disparo</span>

          <v-tooltip right max-width="245">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon small color="cinza-0" class="ml-3 mb-5">info</mf-icon>
              </span>
            </template>
            <span>O Número de disparo é o seu canal direto com o cliente. Todas as suas campanhas serão enviadas através desse número.</span>
          </v-tooltip>

          <v-spacer />
          <mf-search v-model="search" outlined hide-details placeholder="Buscar disparador" />
        </v-card-title>
        <v-card-text v-if="!numbers.length">
          <v-container class="pa-0" fluid fill-height>
            <v-row justify="center" align="center">
              <div class="void-numbers">
                <v-container class="pa-0" fluid fill-height>
                  <v-row justify="center" align="center">
                    <p class="text-info">Nenhum número foi adicionado ainda</p>
                    <mf-button label="Adicionar número" @click="openNumberDialog" />
                  </v-row>
                </v-container>
              </div>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text v-else class="px-0">
          <v-data-table :items="items" :headers="headers" :items-per-page="5" :footer-props="{ itemsPerPageOptions: [5, 10, 15, -1] }">
            <template v-slot:header.nof_contacts="{ header }">
              {{ header.text }}

              <v-tooltip top max-width="245">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <mf-icon small color="cinza-0">info</mf-icon>
                  </span>
                </template>
                <span>Um contato é um número de whatsapp que se inscreveu nesse canal mandando mensagem para o número divulgado</span>
              </v-tooltip>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <mf-icon fill :color="statusColor(item.connection_status)">fiber_manual_record</mf-icon>
                  {{ statusText(item.connection_status) }}
                </td>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ formatNumber(item.number) }}
                </td>
                <td>
                  {{ formatNumberType(item.type) }}
                </td>
                <td>
                  {{ item.nof_contacts | localeString(0) }}
                </td>
                <td>
                  <v-menu>
                    <template v-slot:activator="{ on }">
                      <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
                    </template>
                    <v-list>
                      <v-list-item @click="removeNumber(item)">
                        <v-list-item-title>Remover</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="isAdmin" @click="configureOnProvider(item)">
                        <v-list-item-title>Configurar no fornecedor</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </v-skeleton-loader>
</template>

<script>
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { QUERY_GET_NUMBERS, QUERY_MAX_NUMBER_OF_SENDERS, MUTATION_DELETE_NUMBER } from '@/modules/campanhas/whatsapp/graphql/index.js'

export default {
  components: {
    AddNumberExternalProvider: () => import('@/modules/campanhas/whatsapp/views/components/AddNumberExternalProvider.vue'),
  },
  data: () => ({
    numbers: [],
    maxQuantityOfNumbers: 0,
    search: null,
    items: [],
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Status',
          value: 'connection_status',
          sortable: true,
          width: '15%',
        },
        {
          text: 'Nome',
          value: 'name',
          sortable: true,
          width: '29%',
        },
        {
          text: 'Número',
          value: 'number',
          sortable: true,
          width: '20%',
        },
        {
          text: 'Tipo',
          value: 'type',
          sortable: true,
          width: '10%',
        },
        {
          text: 'Contatos',
          value: 'nof_contacts',
          sortable: true,
          width: '18%',
        },
        {
          sortable: false,
          width: '5%',
        },
      ]
    },
    isAdmin() {
      return this.$getIsAdmin()
    },
  },
  apollo: {
    numbers: {
      query: QUERY_GET_NUMBERS,
      update({ getNumbers }) {
        this.items = getNumbers
        return getNumbers
      },
    },
    maxQuantityOfNumbers: {
      query: QUERY_MAX_NUMBER_OF_SENDERS,
      update({ getMaxNofSenders }) {
        return getMaxNofSenders
      },
    },
  },
  watch: {
    search: {
      handler(value) {
        if (value) {
          this.items = this.numbers.filter((number) => {
            return number.name.toLowerCase().includes(value.toLowerCase()) || number.number.includes(value)
          })
          return
        }
        this.items = this.numbers
      },
      immediate: true,
    },
  },
  methods: {
    statusText(status) {
      if (status === 'ONLINE') return 'Online'
      if (status === 'OFFLINE') return 'Offline'
      if (status === 'INACTIVE') return 'Indisponível'
      return 'Conectando'
    },
    statusColor(status) {
      if (status === 'ONLINE') return '#26a95d'
      if (status === 'OFFLINE') return '#e74c3c'
      if (status === 'INACTIVE') return '#d2d6d9'
      return '#ffe336'
    },
    openNumberDialog() {
      this.numberDialog = true
    },
    refresh() {
      this.$apollo.queries.numbers.refetch()
    },
    formatNumber(number) {
      return phoneNumberFormat(number)
    },
    formatNumberType(type) {
      switch (type) {
        case 'SENDER':
          return 'Disparador'
        case 'ROUTER':
          return 'Roteador'
        default:
          return '-'
      }
    },
    removeNumber(number) {
      this.$confirm({
        title: 'Remover número de disparo',
        message: 'Caso prossiga, todos os contatos desse número não serão apresentados até este número ser adicionado novamente. Deseja continuar?',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
        confirmColor: 'primary',
      })
        .then(async () => {
          await this.$apollo.mutate({ mutation: MUTATION_DELETE_NUMBER, variables: { id: number._id } })
          this.refresh()
        })
        .catch(() => {
          this.$snackbar({ message: 'Erro ao remover número.', snackbarColor: 'error' })
        })
    },
    configureOnProvider(number) {
      // This is a placeholder methods that will be implemented in a future step
      console.log('Configuring on provider', number)
    },
  },
}
</script>

<style lang="scss">
.multi-numbers {
  .void-numbers {
    margin-top: 40px;
  }

  th {
    @extend .column-title;
  }
  td {
    @extend .texto-corrido;
  }
  .text-info {
    opacity: 0.5;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.22;
    letter-spacing: 0.29px;
    text-align: center;
    color: $preto;
  }
  .numbers-quantity {
    opacity: 0.5;
    font-size: 15px;
    line-height: 1.2;
    letter-spacing: 0.24px;
  }
  .max-numbers-message {
    opacity: 0.5;
    font-size: 12px;
    line-height: 1.25;
    letter-spacing: 0.19px;
    margin-left: 8px;
  }
  .numbers-list {
    user-select: none;
    .smartphone {
      opacity: 0.5;
    }
    .name {
      opacity: 0.8;
      font-size: 12px;
      line-height: 1.25;
      letter-spacing: 0.19px;
      color: $preto;
    }
    .number {
      opacity: 0.8;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.2;
      letter-spacing: 0.24px;
      color: $preto;
    }
    .status {
      opacity: 0.5;
      font-size: 12px;
      line-height: 1.25;
      letter-spacing: 0.19px;
      color: $preto;
    }
  }
}
</style>
